import React, { useEffect, useReducer, useState } from 'react'
import { Dialog, DialogTrigger } from '@/Components/ui/dialog'
import { Button } from '@/Components/ui/button'
import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import { useAuth } from '@/Context/AuthContext'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'
import WorkflowService from '@/Service/WorkflowService'
import WorkflowColumn from './WorkflowColumn'

const WorkFlowListing = () => {
    const { userInfo } = useAuth()
    const navigate = useNavigate()

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalWorkflow: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        deleteId: [],
        allcheck: false,
        workflow: [],
        workflowSearch: '',
        isOpen: false,
        queryParam: {
            page: 1,
            action: '',
        },
    })
    const [debouncedWorkflowValue] = useDebounce(event.workflowSearch, Constant.DEBOUNCE_DELAY)
    const location = useLocation()

    const getWorkflow = async () => {
        updateEvent({ isDataFetching: true, workflow: [] })
        try {
            const resp = await WorkflowService.getWorkflows(event.queryParam)
            if (resp.data.success) {
                updateEvent({ workflow: resp.data.data, totalWorkflow: resp.data.pagination.total_record })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getWorkflow()
    }, [event.queryParam.page, event.queryParam.action])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                action: debouncedWorkflowValue,
            },
        })
    }, [debouncedWorkflowValue])

    const deleteWorkflow = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })

            return false
        }
        try {
            const resp = await WorkflowService.deleteWorkflow(event.deleteId)
            if (resp.data.success) {
                getWorkflow()
            }

            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {}
        updateEvent({ deleteConfirmationOpen: false })
    }
    function createWorkflow() {
        navigate('/workflow/create-workflow')
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.USER.CREATE, userInfo.roles) && (
                        <Button className="bg-primary-btn hover:bg-primary-purpal" onClick={createWorkflow}>
                            <SquarePlus />
                            Add Workflow
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={deleteWorkflow}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.workflowSearch}
                        onChange={(e) => updateEvent({ workflowSearch: e.target.value })}
                        placeholder="Workflow"
                    />
                </div>
                <Datatable
                    columns={WorkflowColumn()}
                    data={event.workflow}
                    totalDataCount={event.totalWorkflow}
                    allcheck={event.allcheck}
                    updateEvent={updateEvent}
                    deleteId={event.deleteId}
                    loading={event.isDataFetching}
                    type={DataTableEnumType.WORKFLOW}
                />
            </BodyCard>
        </>
    )
}

export default WorkFlowListing
